const baseUrl = process.env.REACT_APP_baseUrl;
const copyUrl = process.env.REACT_APP_copyUrl;
const buyUrl = process.env.REACT_APP_buyUrl;

export { baseUrl, copyUrl, buyUrl };
